module.exports = __webpack_public_path__ + "img/google_ads-icon.501d87d1.svg";